import { VinMovementData, VinPositionsData } from '@/types';
import { Core, VIN_MOVEMENTS, VIN_POSITIONS } from '../Core';

class Vin extends Core {
  getVinMovements = async () => this.get<VinMovementData>(VIN_MOVEMENTS());

  getVinPositions = async (vin?: string) =>
    this.get<VinPositionsData>(VIN_POSITIONS(vin));
}

export const vin = new Vin();
